import { useDisconnect } from '@puzzlehq/sdk';
import { useNavigate } from '@tanstack/react-router';
import { Route as index_route } from '@src/routes/index.js';
import {
  HStack,
  Text,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogOverlay,
  DialogClose,
  DialogFooter,
  Button,
} from 'ui_2';
import { usePuzzleGameContext } from '@src/providers/puzzleProvider';

const dAppNetwork: string = import.meta.env.VITE_NETWORK!;

export const IncorrectNetworkModal = () => {
  const { network } = usePuzzleGameContext();
  const { disconnect, loading } = useDisconnect();
  const navigate = useNavigate();

  const showDialog =
    network !== undefined &&
    dAppNetwork !== undefined &&
    network.toString() !== dAppNetwork;

  return (
    <Dialog open={showDialog}>
      <DialogOverlay className='bg-gray-900/40' />
      <DialogContent
        aria-describedby='network-description'
        className='z-[1000] w-4/5 max-w-[400px] rounded-[10px] border border-aqua bg-[#13252c]'
        showOverlay={false}
        showClose={false}
      >
        <DialogHeader>
          <DialogTitle className='text-center text-aqua'>
            <Text family='space' color='aqua' id='network-description'>
              Puzzle Wallet Network is incorrect!
            </Text>
          </DialogTitle>
          <DialogClose className='text-aqua' />
        </DialogHeader>
        <Text family='space' font='sm' color='aqua'>
          This dApp is only available on {dAppNetwork.replace('Aleo', '')}.
          Please switch the network in your wallet to continue playing.
        </Text>
        <Text family='space' font='sm' color='aqua'>
          If you just switched networks, this message will disappear shortly.
        </Text>
        <DialogFooter className='w-full'>
          <HStack className='w-full px-4'>
            <Button
              variant='mysteryCitySecondary'
              fullWidth
              disabled={loading}
              onClick={() => {
                disconnect();
                navigate({ to: index_route.to });
              }}
            >
              Disconnect Wallet
            </Button>
          </HStack>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
